import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonDataState, initialState } from './commonDataState';

export const commonDataSlice = createSlice({
    name: 'commonData',
    initialState,
    reducers: {
        setShowQuickGuide: (state: CommonDataState, action: PayloadAction<boolean>) => {
            state.showQuickGuide = action.payload;
        },
    },
});

export const { setShowQuickGuide } = commonDataSlice.actions;

export default commonDataSlice.reducer;
